import { multiRoomRateAddToBasket, roomRateAddToBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import React from 'react';
import { connect } from 'react-redux';
import { RoomRateConfigurationWizard } from './RoomRateConfigurationWizard';
import {
  RoomRateConfigurationWizardDispatchProps,
  RoomRateConfigurationWizardOwnProps,
  RoomRateConfigurationWizardStoreProps,
} from './RoomRateForm.types';

const mapStateToProps = (state): RoomRateConfigurationWizardStoreProps => ({
  basketGuests: basketSelectors.getBasketGuests(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  isFetching: basketSelectors.getIsBasketDetailsFetching(state),
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  loggedGuest: guestSelectors.getGuest(state),
});

const mapDispatchToProps = (dispatch): RoomRateConfigurationWizardDispatchProps => ({
  roomRateAddToBasket: roomRateAddToBasket(dispatch),
  multiRoomRateAddToBasket: multiRoomRateAddToBasket(dispatch),
});

export const RoomRateConfigurationWizardConnected: React.ComponentType<RoomRateConfigurationWizardOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(RoomRateConfigurationWizard);
